import React, { useState, useEffect } from "react"
import Loader from "react-loader-spinner"
import Button from "../../../shared/components/atoms/button/button"
import { graphql, useStaticQuery, withPrefix } from "gatsby"

import "./step5-register.scss"
import { registerStepDatalayer } from "../../../utils/registerDatalayer"
const Step5Register = props => {
  const { loadingButton } = props

  if (props.userData) {
    if (props.userData.password === null && !props.adult) {
      window.location.href = withPrefix("/correo")
    }
  } else {
    if (typeof window !== "undefined") {
      window.location.href = withPrefix("/correo")
    }
  }
  const [latLngCountry] = React.useState(() => {
    switch (process.env.LOCALE) {
      case "es-PE":
        return {
          lat: -12.046374,
          lng: -77.042793,
        }
      case "es-EC":
        return {
          lat: 0.22985,
          lng: 101.4750519,
        }
      case "es-BO": // La Paz
        return {
          lat: -16.502534,
          lng: -68.135251,
        }
      case "es-CL": // Santiago de chile
        return {
          lat: -33.4372,
          lng: -70.6506,
        }
      default:
        return {
          lat: 4.624335,
          lng: -74.063644,
        }
    }
  })

  const resultQuery = useStaticQuery(
    graphql`
      query ADRESS_QUERY_REGISTER {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            node_locale
            codigoIcu
            titulo
            departamentos {
              codigo
              nombre
            }
            ciudades {
              codigo
              codigoDepartamento
              nombre
            }
          }
        }
      }
    `
  )

  var adressContentful = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0]

  const [cities, setCities] = React.useState(adressContentful.ciudades)
  const [adress, setAdress] = React.useState({ search: "", value: "" })
  const [neighbor, setNeighbor] = React.useState("")

  const handleChangecountryState = e => {
    props.handleChange(e)
    setCities(
      adressContentful.ciudades.filter(
        info => info.codigoDepartamento === e.target.value
      )
    )
  }

  const handleInputAddressChange = e => {

    let __address = { search: e.target.value, value: e.target.value }
    setAdress(() => __address)
    props.setValues({ ...props.values, address: __address.value })
  }

  const handleInputNeighborChange = e => {
    setNeighbor(e.target.value)
    props.handleChange(e)
  }

  const handleInputAdditionalInfoChange = e => {
    props.handleChange(e)
  }

  const handleDatalayer = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "gaEvent",
      eventTrigger: "Register",
      eventCategory: "Form",
      eventAction: "Submit",
      eventLabel: "Register", //this have to be dynamically pushed.
      eventValue: undefined,
    })
  }

  useEffect(() => {
    if (process.env.LOCALE === "es-PR") {
      setCities(adressContentful.ciudades)
    }
  }, [])

  const labelState =
    process.env.LOCALE === "es-PE"
      ? "ELIGE UN ESTADO O DEPARTAMENTO"
      : process.env.LOCALE === "es-EC" ||
        process.env.LOCALE === "es-AR" ||
        process.env.LOCALE === "es-DO" ||
        process.env.LOCALE === "es-UY"
      ? "ELIGE UNA PROVINCIA"
      : process.env.LOCALE === "es-CL"
      ? "ELIGE UNA REGIÓN"
      : "ELIGE UN DEPARTAMENTO"

  const singleLabel =
    process.env.LOCALE === "es-EC" ||
    process.env.LOCALE === "es-AR" ||
    process.env.LOCALE === "es-DO" ||
    process.env.LOCALE === "es-UY"
      ? "Provincia"
      : process.env.LOCALE === "es-CL"
      ? "Región"
      : "Departamento"

  const copieAddress =
    process.env.LOCALE === "es-PE" ? (
      "Te pedimos esta información para estar en contacto contigo y hacerte llegar algún premio en caso de ser ganadora o nuestros productos."
    ) : (
      <>
        Te pedimos esta información para{" "}
        <span className="color-pink">hacerte llegar algún premio</span> en caso
        de ser ganadora de alguna de nuestras actividades.
      </>
    )

    const copieCity =
    process.env.LOCALE === "es-PR"
      ? "Municipio"
      : process.env.LOCALE === "es-PE"
      ? "Distrito"
      : process.env.LOCALE === "es-AR"
      ? "Barrio"
      : "Ciudad";

const copieACity =
    process.env.LOCALE === "es-PR"
      ? "UN MUNICIPIO"
      : process.env.LOCALE === "es-PE"
      ? "UN DISTRITO"
      : process.env.LOCALE === "es-AR"
      ? "UN BARRIO"
      : "UNA CIUDAD";

  const houseCopie =
    process.env.LOCALE === "es-PE"
      ? "Urbanización / N° Departamento / Referencia"
      : process.env.LOCALE === "es-DO"
      ? "Sector / edificio / apartamento"
      : "Barrio / edificio / apartamento"

  const copieExample =
    process.env.LOCALE === "es-PE"
      ? "Ejemplo: Urbanización El Portal, Apto 1005, unidad portal Del Valle"
      : process.env.LOCALE === "es-DO"
      ? "Ejemplo: Sector El Portal, unidad portal Del Valle, Apto 1005"
      : "Ejemplo: Barrio El Portal, unidad portal Del Valle, Apto 1005"

  return (
    <>
      <form
        onSubmit={props.handleSubmit(() => {
          handleDatalayer()
          registerStepDatalayer({
            category: "registro_5",
            label: props.adult ? "finalizar" : "siguiente",
          })
          props.onSubmit(props.adult ? "register" : "")
        })}
      >
        <div className="f-step-register-form">
          <p className="f-step-register-copy">{copieAddress}</p>
          <div className="f-step-register-form-item">
            {process.env.LOCALE !== "es-PR" && (
              <div>
                <label>
                  {labelState}
                  {props.adult && process.env.LOCALE !== "es-PE" || "es-AR" && (
                    <span> (Opcional)</span>
                  )}
                </label>
                <select
                  className={
                    props.errors.countryState
                      ? "f-form-countryState f-error-value"
                      : "f-form-countryState"
                  }
                  name="countryState"
                  autoComplete="off"
                  id={"outlined-countryState"}
                  onChange={handleChangecountryState}
                  ref={props.register({
                    required: process.env.LOCALE === "es-PE" || "es-AR",
                  })}
                >
                  <option value="">{singleLabel}</option>
                  {adressContentful.departamentos.map(info => (
                    <option key={info.codigo} value={info.codigo}>
                      {info.nombre}
                    </option>
                  ))}
                </select>
                <span className="icon-down icon-select icon-selectAdress" />
                <span className="f-step-register-form-error f-step-register-form-error-label">
                {Object.keys(props.errors).length > 0 &&
                  props.errors.countryState?.type === "required" ? "Debes completar este campo" : ''
                }
              </span>
              </div>
            )}
            <div>
              <label>
                ELIGE {copieACity}
                {props.adult && process.env.LOCALE !== "es-PE" || "es-AR" && (
                  <span> (Opcional)</span>
                )}
              </label>
              <select
                className={
                  props.errors.city
                    ? "f-form-city f-error-value"
                    : "f-form-city"
                }
                name="city"
                autoComplete="off"
                id={"outlined-city"}
                onChange={props.handleChange}
                ref={props.register({
                  required: process.env.LOCALE === "es-PE" || "es-AR",
                })}
              >
                <option value="">{copieCity}</option>
                {cities.map((info, index) => (
                  <option key={index} value={info.codigo}>
                    {info.nombre}
                  </option>
                ))}
              </select>
              <span className="icon-down icon-select icon-selectAdress" />
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {Object.keys(props.errors).length > 0 &&
                  props.errors.city?.type === "required" ? "Debes completar este campo" : ''
                }
              </span>
            </div>

            {process.env.LOCALE === "es-PR" && (
              <div>
                <label>
                  ZIPCODE
                  {adress.value === "" ? (
                    <span> (Opcional)</span>
                  ) : (
                    <span> (Requerido)</span>
                  )}
                </label>
                <input
                  placeholder="Zipcode"
                  type="text"
                  name="zipcode"
                  maxLength="10"
                  className={
                    props.errors.zipcode
                       ? "f-error-value"
                       : ""
                  }
                  autoComplete="off"
                  onChange={event => {
                    props.handleChange(event)
                  }}
                  ref={props.register({
                    required: adress.value !== "",
                    maxLength: 10,
                    minLength: 5,
                    pattern: /^[0-9]*$/gi,
                  })}
                />
              <p className="f-step-register-copy">Ejemplo: 00665</p>
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {Object.keys(props.errors).length > 0 &&
                  props.errors.zipcode?.type === "required"
                  ? "Debes completar este campo"
                  : props.errors.zipcode?.type === "minLength"
                  ? "El código debe tener al menos 5 caracteres"
                  : props.errors.zipcode?.type === "maxLength"
                  ? "El código debe tener como máximo 10 caracteres"
                  : props.errors.zipcode?.type === "pattern"
                  ? "El código tiene caracteres inválidos"
                  : null
                }
              </span>
              </div>
            )}
          </div>
          <div className="f-step-register-form-item">
            {process.env.LOCALE !== "es-AR" && 
              <div>
              <label>
                TU BARRIO
                {props.adult && process.env.LOCALE !== "es-PE" && (
                  <span> (Opcional)</span>
                )}
              </label>
              <input
                name="neighbor"
                type="text"
                value={neighbor}
                placeholder="Barrio / zona / localidad"
                onChange={handleInputNeighborChange}
                // className="f-register-address-additional"
              />
            </div>}

            <div>
              <label>
                TU DIRECCIÓN
                {props.adult && process.env.LOCALE !== "es-PE" || "es-AR" && (
                  <span> (Opcional)</span>
                )}
              </label>
              <input
                placeholder="Dirección"
                type="text"
                name="adress"
                value={adress.value}
                autoComplete="off"
                onChange={event => {
                  if (!/^[a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_\-\s]*$/.test(event.target.value)) {
                    return false;
                  }
                  else {
                    handleInputAddressChange(event)
                  }
                }}
                ref={props.register({
                  required: process.env.LOCALE === "es-AR",
                })}
                className={
                  props.errors.adress
                     ? "f-error-value"
                     : ""
                }
                // className="f-register-address-additional"
              />
               <span className="f-step-register-form-error f-step-register-form-error-label">
                {Object.keys(props.errors).length > 0 &&
                  props.errors.adress?.type === "required" ? "Debes completar este campo" : ''
                }
              </span>
            </div>
          </div>

          <div className="f-step-register-form-item">
            <div>
              <label>
                DATOS ADICIONALES DE TU UBICACIÓN
                {props.adult && process.env.LOCALE !== "es-PE" && (
                  <span> (Opcional)</span>
                )}
              </label>
              <input
                placeholder={houseCopie}
                type="text"
                name="addressAdditional"
                value={props.values.addressAdditional}
                maxLength="60"
                className={
                  `f-form-address-additional
                  ${props.errors.address ? 'f-error-value' : ''}
                  ${process.env.LOCALE === "es-AR" ? 'f-form-address-additional-auto' : ''}`
                }
                autoComplete="off"
                id={"outlined-address-additional"}
                onChange={event => {
                  if (!/^[a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_\-\s]*$/.test(event.target.value)) {
                    return false;
                  }
                   else {
                    props.handleChange(event)
                  }
                }}
                ref={props.register({
                  required: process.env.LOCALE === "es-PE",
                })}
              />
              <p className="f-step-register-copy">{copieExample}</p>
            </div>
            {process.env.LOCALE === "es-AR" && (
              <div>
                <label>
                  CÓDIGO POSTAL<br/>
               <br />
                  </label>
                <input
                  placeholder="Código postal"
                  type="text"
                  name="zipcode"
                  maxLength="8"
                  className={
                    props.errors.zipcode
                       ? "f-error-value"
                       : ""
                  }
                  autoComplete="off"
                  onChange={event =>{
                    props.handleChange(event)
                  }}
                  ref={props.register({
                    required: process.env.LOCALE === "es-AR",
                    pattern: /^[A-Z0-9]*$/gi,
                    maxLength: 8,
                    minLength: 4,
                  })}
                />
              <p className="f-step-register-copy">Ejemplo: F1234FDA</p>
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {Object.keys(props.errors).length > 0 &&
                  props.errors.zipcode?.type === "required"
                  ? "Debes completar este campo"
                  : props.errors.zipcode?.type === "minLength"
                  ? "El código debe tener al menos 4 caracteres"
                  : props.errors.zipcode?.type === "maxLength"
                  ? "El código debe tener como máximo 8 caracteres"
                  : props.errors.zipcode?.type === "pattern"
                  ? "El código tiene caracteres inválidos"
                  : null
                }
              </span>
              </div>
            )}
          </div>
        </div>
        <div
          className={
            !props.loadServer
              ? "f-step-register-buttons"
              : "f-step-register-buttons f-step-register-buttons-disable"
          }
        >
          {loadingButton ? (
            <Loader type="TailSpin" color="#FF409B" height={50} width={50} />
          ) : (
            props.adult && (
              <Button
                className="new-primary-pink short f-btn-form-nextStep"
                title="Finalizar"
                type="submit"
              />
            )
          )}
          {!props.adult && (
            <Button
              className="new-primary-pink short f-btn-form-nextStep"
              title="Siguiente"
              type="submit"
            />
          )}
          <div
            className="f-step-register-buttons-back"
            onClick={e => {
              registerStepDatalayer({
                category: "registro_5",
                label: "anterior",
              })
              props.hadleBack && props.hadleBack(e)
            }}
          >
            <Button
              className="new-primary-pink--outline short f-btn-form-prevStep"
              title="Anterior"
            />
          </div>
        </div>
      </form>
    </>
  )
}

export default Step5Register
